import React from 'react';
import { useNotifications, Notification } from '../contexts/NotificationContext';
import './NotificationCenter.css';

const NotificationCenter: React.FC = () => {
  const { state, markAsRead, markAllAsRead, removeNotification, clearAllNotifications, hideNotifications } = useNotifications();

  const formatTime = (date: Date) => {
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return 'Ahora';
    if (minutes < 60) return `${minutes}m`;
    if (hours < 24) return `${hours}h`;
    return `${days}d`;
  };

  const getNotificationIcon = (type: Notification['type']) => {
    switch (type) {
      case 'success':
        return '✅';
      case 'warning':
        return '⚠️';
      case 'error':
        return '❌';
      default:
        return 'ℹ️';
    }
  };

  const handleNotificationClick = (notification: Notification) => {
    if (!notification.read) {
      markAsRead(notification.id);
    }
    
    // Aquí se manejarían las acciones específicas
    if (notification.action) {
      switch (notification.action.type) {
        case 'navigate':
          // Navegar a la pantalla específica
          break;
        case 'open_chat':
          // Abrir chat
          break;
        case 'view_job':
          // Ver trabajo
          break;
      }
    }
    
    hideNotifications();
  };

  if (!state.showNotifications) return null;

  return (
    <div className="notification-overlay" onClick={hideNotifications}>
      <div className="notification-center" onClick={(e) => e.stopPropagation()}>
        <div className="notification-header">
          <h3>Notificaciones</h3>
          <div className="notification-actions">
            {state.unreadCount > 0 && (
              <button 
                className="mark-all-read-btn"
                onClick={markAllAsRead}
              >
                Marcar todas como leídas
              </button>
            )}
            {state.notifications.length > 0 && (
              <button 
                className="clear-all-btn"
                onClick={clearAllNotifications}
              >
                Limpiar todo
              </button>
            )}
            <button 
              className="close-btn"
              onClick={hideNotifications}
            >
              ✕
            </button>
          </div>
        </div>

        <div className="notification-list">
          {state.notifications.length === 0 ? (
            <div className="empty-notifications">
              <div className="empty-icon">🔔</div>
              <p>No tienes notificaciones</p>
              <span>Las notificaciones aparecerán aquí</span>
            </div>
          ) : (
            state.notifications.map((notification) => (
              <div
                key={notification.id}
                className={`notification-item ${!notification.read ? 'unread' : ''}`}
                onClick={() => handleNotificationClick(notification)}
              >
                <div className="notification-icon">
                  {getNotificationIcon(notification.type)}
                </div>
                <div className="notification-content">
                  <div className="notification-title">
                    {notification.title}
                    {!notification.read && <span className="unread-dot"></span>}
                  </div>
                  <div className="notification-message">
                    {notification.message}
                  </div>
                  <div className="notification-time">
                    {formatTime(notification.timestamp)}
                  </div>
                </div>
                <button
                  className="remove-notification-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeNotification(notification.id);
                  }}
                >
                  ×
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationCenter; 